import { ActionTypes, PaidNewslettersStripeAccountFetchAction, PaidNewslettersStripeAccountFetchErrorAction, PaidNewslettersStripeAccountFetchSuccessAction, PaidNewslettersStripeAccountState, PaidNewslettersStripeAccountUpdateAction, PaidNewslettersStripeAccountUpdateErrorAction, PaidNewslettersStripeAccountUpdateSuccessAction  } from './types';
import { ApplicationState } from '..';


export const PaidNewslettersStripeAccountFetch = (): PaidNewslettersStripeAccountFetchAction => ({
    type: ActionTypes.FETCH_START
});
export const PaidNewslettersStripeAccountFetchSuccess = (paidNewslettersStripeAccount): PaidNewslettersStripeAccountFetchSuccessAction => ({
    type: ActionTypes.FETCH_SUCCESS,
    payload: {
        paidNewslettersStripeAccount
    },
});
export const PaidNewslettersStripeAccountFetchError = (): PaidNewslettersStripeAccountFetchErrorAction => ({
    type: ActionTypes.FETCH_ERROR,
});

export const PaidNewslettersStripeAccountUpdate = (ReturnUrl: string, RefreshUrl?: string): PaidNewslettersStripeAccountUpdateAction => ({
    type: ActionTypes.UPDATE_START,
    payload: {
        ReturnUrl,
        RefreshUrl
    },
    meta: {
        thunk: true,
    },
});
export const PaidNewslettersStripeAccountUpdateSuccess = (meta: Record<string, any>): PaidNewslettersStripeAccountUpdateSuccessAction => ({
    type: ActionTypes.UPDATE_SUCCESS,
    payload: null,
    meta
});
export const PaidNewslettersStripeAccountUpdateError = (meta: Record<string, any>): PaidNewslettersStripeAccountUpdateErrorAction => ({
    type: ActionTypes.UPDATE_ERROR,
    error: true,
    meta
});

export const getPaidNewslettersStripeAccountStore = (store: ApplicationState): PaidNewslettersStripeAccountState => store.paidNewslettersStripeAccount || {} as PaidNewslettersStripeAccountState;
